import React from 'react'

export default ({ page }) => {
  return (
    <div className="text-content accordion-content">
      <p>
        <a
          className="download-link"
          href={page.acf.audit.url.source_url}
          target="_blank"
        >
          {page.acf.audit.title}
        </a>
      </p>
    </div>
  )
}
